import { DocumentsDataTableDocument } from 'generated/resources/datatable.graphql'
import {
  CreateDocumentsDocument,
  CreateDocumentsMutation,
  CreateDocumentsMutationVariables,
  DocumentsDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useCreateDocuments = () => {
  const [createDocuments, { loading }] = useMutation(CreateDocumentsDocument, {
    extractorFn: (data: CreateDocumentsMutation) =>
      data.documentsMutations.bulkCreateDocumentsDocument,
  })

  return {
    loading,
    createDocuments(variables: CreateDocumentsMutationVariables) {
      return createDocuments({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [DocumentsDocument, DocumentsDataTableDocument],
      })
    },
  }
}

export default useCreateDocuments
